const PropTypes = require('prop-types');
// @vendor
const React = require('react');

// @utils
const { formatText } = require('core/i18n').i18n;

// @constants
const { BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, TYPE_WARRANTS } = require('constants/index');
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
// @components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');

class WarrantsFilters extends React.Component {
    constructor(props) {
        super(props);

        this.handleWarrantProductChange = this.handleWarrantProductChange.bind(this);
        this.handleUnderlyingChange = this.handleUnderlyingChange.bind(this);
        this.handleCallPutChange = this.handleCallPutChange.bind(this);
        this.handleIssuerChange = this.handleIssuerChange.bind(this);
        this.onHandleExpirationChange = this.onHandleExpirationChange.bind(this);
    }

    onHandleExpirationChange(date) {
        this.props.onHandleFieldChange('expiration', date);
    }

    adaptCallPutOptions(options) {
        options = options.toJS();
        return [
            { value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsF') },
            ...options.map(item => {
                return { value: item.typeId, label: item.description };
            })
        ];
    }

    adaptIssuersOptions(options) {
        options = options.toJS();
        return [
            { value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsM') },
            ...options.map(item => {
                return { value: item.issuerId, label: item.description };
            })
        ];
    }

    adaptSelectOptions(options) {
        options = options.toJS();
        return [
            { value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsM') },
            ...options.map(item => {
                return { value: item.productId, label: item.description };
            })
        ];
    }

    adaptUnderlyingOptions(options) {
        options = options.toJS();
        return [
            { value: BROKER_ADVANCED_SEARCH_DEFAULT_ALL_VALUE, label: formatText('broker-allOptionsM') },
            ...options.map(item => {
                return {
                    value: `${item.exchangeId}__${item.spcSymbol}`,
                    label: item.instrument,
                    ids: {
                        spcSymbol: item.spcSymbol,
                        exchangeId: item.exchangeId
                    }
                };
            })
        ];
    }

    handleCallPutChange(callput) {
        this.props.onHandleFieldChange('type', callput.value);
    }

    handleIssuerChange(issuer) {
        this.props.onHandleFieldChange('issuer', issuer.value);
    }

    handleUnderlyingChange(underlying) {
        this.props.onHandleFieldChange('underlying', underlying);
    }

    handleWarrantProductChange(warrantProduct) {
        this.props.onHandleFieldChange('product', warrantProduct.value);
    }

    render() {
        const { searchState } = this.props;

        const productTypes = this.adaptSelectOptions(searchState.getIn(['filters', TYPE_WARRANTS, 'products']));
        const underlyings = this.adaptUnderlyingOptions(searchState.getIn(['filters', TYPE_WARRANTS, 'underlyings']));
        const callPuts = this.adaptCallPutOptions(searchState.getIn(['filters', TYPE_WARRANTS, 'types']));
        const issuers = this.adaptIssuersOptions(searchState.getIn(['filters', TYPE_WARRANTS, 'issuers']));

        const activeProductType = searchState.getIn(['selectedValues', TYPE_WARRANTS, 'product']);
        const activeUnderlying = searchState.getIn(['selectedValues', TYPE_WARRANTS, 'underlying', 'value']);
        const activeCallPut = searchState.getIn(['selectedValues', TYPE_WARRANTS, 'type']);
        const activeIssuer = searchState.getIn(['selectedValues', TYPE_WARRANTS, 'issuer']);
        const activeExpiration = searchState.getIn(['selectedValues', TYPE_WARRANTS, 'expiration']);

        return (
            <div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchWarrantProductType"
                            label="broker-advancedSearchWarrantProductTypeLabel"
                            name="advanced-search-warrant-product-type"
                            options={productTypes}
                            value={activeProductType}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleWarrantProductChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchUnderlying"
                            label="broker-advancedSearchUnderlyingLabel"
                            name="advanced-search-underlying"
                            options={underlyings}
                            value={activeUnderlying}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleUnderlyingChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchCallPut"
                            label="broker-advancedSearchCallPutLabel"
                            name="advanced-search-currency"
                            options={callPuts}
                            value={activeCallPut}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleCallPutChange}
                        />
                    </div>
                </div>
                <div className="broker-advanced-search-explore__full-row">
                    <div className="broker-advanced-search-explore__one-third-box">
                        <OKSelect
                            id="selBrokerAdvancedSearchIssuer"
                            label="broker-advancedSearchIssuerLabel"
                            name="advanced-search-issuers"
                            options={issuers}
                            value={activeIssuer}
                            clearable={false}
                            searchable={false}
                            onChange={this.handleIssuerChange}
                        />
                    </div>
                    <div className="broker-advanced-search-explore__one-third-box">

                        <DatePickerCustom
                            callback={this.onHandleExpirationChange}
                            selectedDate={activeExpiration}
                            label={formatText("broker-advancedSearchExpirationDate")}
                            minDate={''}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

WarrantsFilters.propTypes = {
    showAdditionalFilters: PropTypes.bool,
    searchState: PropTypes.object.isRequired,
    onHandleFieldChange: PropTypes.func.isRequired,
    onHandleToggleAdditionalFilters: PropTypes.func,
};

module.exports = WarrantsFilters;
